<div class="lei-details-box">
  <mat-card>

    <div class="card-header" (click)="onArrowClick($event)">
      <span [@arrowRotate]="arrowRotate" class="glyphicon glyphicon-chevron-right arrow-right" aria-hidden="true"></span>
      <div class="header-text">
        <div><small>Legal Entity</small>&nbsp; <strong>{{ leiDetail.legalEntityId }}</strong>&nbsp; {{ leiDetail.legalName ? '(' + leiDetail.legalName + ')' : '' }}</div>
        <div class="price"*ngIf="leiDetail.mifidInScope === 'IN'">Cost of electronic access to Research: {{(showResearchCost()) | currency  :'USD': 'code' :'1.0-0'}}</div>
        <div *ngIf="leiDetail.leiCorrelationId != 0" class="remove"><a (click)="removeCurrentLei()">Remove</a></div>
      </div>
    </div>

    <div class="card-body" [@signal]="signal">

      <fieldset>

        <div class="flex">

          <mat-form-field class="horizontal">
          <!--<mat-input-container>-->
            <div style="position: relative;padding-right:30px;">
              <i style="position: absolute;right: -19px;top: 2px;" class="material-icons help-icon" matTooltip="A Legal Entity Identifier (or LEI), is a 20-character identifier that identifies distinct legal entities that engage in financial transactions.">&#xE8FD;</i>
              <input autofocus maxlength="20" #legalEntityIdInput placeholder="Legal Entity Identifier *" matInput name="legalEntityId" (keyup)="setNavigationDisable()" [formControl]="legalEntityIdFormControl" [(ngModel)]="leiDetail.legalEntityId">
            </div>
            <mat-error *ngIf="legalEntityIdFormControl.hasError('required')">
              Legal Entity Identifier is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="legalEntityIdFormControl.hasError('minlength')">
              Legal Entity Identifier should be <strong>20 characters long.</strong>
            </mat-error>
          <!--</mat-input-container>-->
            </mat-form-field>


          <mat-form-field class="horizontal">
            <input matInput placeholder="Client Legal Name *" name="legalName" (keyup)="setNavigationDisable()" [formControl]="legalEntityNameFormControl" [(ngModel)]="leiDetail.legalName">
            <mat-error *ngIf="legalEntityNameFormControl.hasError('required')">
              Client Legal Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>


          <mat-form-field class="horizontal">
            <input type="text" placeholder="Country of Incorporation *" aria-label="Number" matInput [formControl]="legalEntityCountryFormControl" [matAutocomplete]="auto"
                   (change)="setNavigationDisable()" [(ngModel)]="leiDetail.domicile">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setNavigationDisable();displayMifidSelection()">
              <mat-option *ngFor="let country of leiCountries | async" [value]="country">
                {{ country }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="legalEntityCountryFormControl.hasError('required')">
              Country of Incorporation is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-select (selectionChange)="onMiFIDChange();copyLei($event)" class="horizontal" name="mifidInScope" placeholder="In scope for MiFID Unbundling? *" (selectionChange)="setNavigationDisable()"  [(ngModel)]="leiDetail.mifidInScope">
              <mat-optgroup label="In scope for MiFID Unbundling? *">
                <mat-option class="multiline-mat-option" *ngFor="let scope of mifidScopes" [value]="scope.value">
                  {{ scope.display  }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>

        </div>

      </fieldset>

      <fieldset *ngIf="this.leiDetail.domicile === 'United Kingdom'  && (leiDetail.mifidInScope === 'IN' || leiDetail.mifidInScope === 'OPTIN')">
      <legend>Package Details</legend>
      <app-lei-package *ngFor="let package of leiDetail.packagesDetails, let i = index, let last = last"
                         [packageDetails]="package" [index]="i" [last]="last"
                         (addPackageToModel)="addMorePackageForm()" [isMifidRebundlingEnabled]="!this.isMifidRebundlingEnabled"
                         [leiDetail] ="this.leiDetail" (PackageDetailsValid)="setNavigationDisable($event)">
      </app-lei-package>
      </fieldset>

      <fieldset *ngIf="(leiDetail.mifidInScope === 'IN' || leiDetail.mifidInScope === 'OPTIN')
                        && isPaymentShowable()">
        <legend>Payment Details</legend>

        <div class="flex form-row">

          <div class="currency">
            <mat-form-field style="width: 92%;">
              <mat-select [disabled]="leiDetail.mifidInScope !== 'IN' && leiDetail.mifidInScope !== 'OPTIN'" class="horizontal" name="prefCurrency" placeholder="Currency of Payment *" (change)="setNavigationDisable()"  [(ngModel)]="leiDetail.paymentDetails.preferredCurrency">
                <mat-optgroup label="Currency of Payment *">
                  <mat-option *ngFor="let currency of currencies" [value]="currency.value">
                    {{ currency.display }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
            <i style="top: 8px;right: 2px;" class="material-icons help-icon" matTooltip="If you are not paying in USD, the USD charge for research will be converted to your payment currency at the applicable FX Rate. FX Rate means in respect of an invoice issued for upfront payments, the WM Reuters 4 p.m. London fix for the applicable currency pair on the last business day of the month prior to the invoice date.">&#xE8FD;</i>
          </div>

          <mat-form-field>
            <mat-select [disabled]="leiDetail.mifidInScope !== 'IN' && leiDetail.mifidInScope !== 'OPTIN'" (selectionChange)="onPaymentMethodChange()"  class="horizontal" name="method" placeholder="Payment Method *" (change)="setNavigationDisable()"  [(ngModel)]="leiDetail.paymentDetails.method">
              <mat-optgroup label="Select Payment Method:">
                <mat-option *ngFor="let method of methods" [value]="method.value">
                  {{ method.display }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select [disabled]="leiDetail.mifidInScope  !== 'IN' && leiDetail.mifidInScope !== 'OPTIN'" class="horizontal" name="vatReg" placeholder="Registered locally for VAT? *" (change)="setNavigationDisable()"  [(ngModel)]="leiDetail.paymentDetails.vatRegistered">
              <mat-optgroup label="Registered locally for VAT?">
                <mat-option *ngFor="let vatOption of vatRegisteredOptions" [value]="vatOption.value">
                  {{ vatOption.display }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>

        </div>

        <div *ngIf="leiDetail.paymentDetails.payViaRPA" class="flex form-row">

          <!--<mat-select [disabled]="!leiDetail.mifidInScope || (leiDetail.paymentDetails.method == 'P&L')" (change)="setNavigationDisable()" class="horizontal" name="payViaRPA" placeholder="Paying via RPA" [(ngModel)]="leiDetail.paymentDetails.payViaRPA">-->
          <!--<mat-option *ngFor="let payViaRPAOption of payViaRPAOptions" [value]="payViaRPAOption.value">-->
          <!--{{ payViaRPAOption.display }}-->
          <!--</mat-option>-->
          <!--</mat-select>-->

          <mat-form-field class="example-wll-width">
            <input matInput placeholder="RPA Administrator Name *" name="rpaAdminName" (keyup)="setNavigationDisable()" [formControl]="rpaAdminNameFormControl" [(ngModel)]="leiDetail.paymentDetails.rpaAdminName">
            <mat-error *ngIf="rpaAdminNameFormControl.hasError('required')">
              RPA Administrator Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <input matInput placeholder="RPA Administrator Email" name="rpaAdminEmail" [formControl]="rpaAdminEmailFormControl" [(ngModel)]="leiDetail.paymentDetails.rpaAdminEmail">
            <mat-error *ngIf="rpaAdminEmailFormControl.hasError('pattern')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <input matInput placeholder="RPA Administrator Phone" name="rpaAdminPhone" [formControl]="rpaAdminPhoneFormControl" [(ngModel)]="leiDetail.paymentDetails.rpaAdminPhone">
          </mat-form-field>

        </div>
        <div class="flex form-row" *ngIf="leiDetail.paymentDetails.vatRegistered">
          <mat-form-field class="example-full-width horizontal">
            <input matInput placeholder="VAT Registration Number *" name="taxNumber" (keyup)="setNavigationDisable()" [formControl]="taxNumberFormControl" [(ngModel)]="leiDetail.paymentDetails.taxNumber">
            <mat-error *ngIf="taxNumberFormControl.hasError('required')">
              VAT Registration Number is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </fieldset>

      <fieldset *ngIf="(leiDetail.mifidInScope === 'IN' || leiDetail.mifidInScope === 'OPTIN')
                        && isPaymentShowable()">
        <legend class="copy-invoice">Invoice Details<label *ngIf="leiDetail.leiCorrelationId != 0"><input type="checkbox"  id="copyInvoice" (change)="copyInvoiceDetails($event)"/> Copy previous details</label></legend>
        <div class="flex form-row">

      .    <mat-form-field class="example-full-width ">
            <input matInput placeholder="Full Name *" name="invoiceName" (keyup)="setNavigationDisable()" [formControl]="invoiceNameFormControl" [(ngModel)]="leiDetail.invoiceDetails.name">
            <mat-error *ngIf="invoiceNameFormControl.hasError('required')">
              Full Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>


          <mat-form-field class="example-full-width ">
            <input matInput placeholder="Email *" name="invoiceEmail" (keyup)="setNavigationDisable()" [formControl]="invoiceEmailFormControl" [(ngModel)]="leiDetail.invoiceDetails.email">
            <mat-error *ngIf="invoiceEmailFormControl.hasError('required')">
              Email is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="invoiceEmailFormControl.hasError('pattern')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>


        </div>

        <div class="flex form-row">

          <mat-form-field class="example-full-width ">
            <input matInput placeholder="Address Line1 *" name="line1" (keyup)="setNavigationDisable()" [formControl]="line1FormControl" [(ngModel)]="leiDetail.invoiceDetails.address.line1">
            <mat-error *ngIf="line1FormControl.hasError('required')">
              Address Line1 is <strong>required</strong>
            </mat-error>
          </mat-form-field>


          <mat-form-field class="example-full-width ">
            <input matInput placeholder="Address Line2 (optional)" name="line2" (keyup)="setNavigationDisable()" [formControl]="line2FormControl" [(ngModel)]="leiDetail.invoiceDetails.address.line2">
          </mat-form-field>
        </div>
        <div class="flex form-row">

          <!--<mat-form-field class="horizontal">-->
          <!--<input matInput placeholder="Address Line3" name="line3" [(ngModel)]="leiDetail.invoiceDetails.address.line3">-->
          <!--</mat-form-field>-->
          <mat-form-field class="example-full-width ">
            <input matInput placeholder="City *" name="city" (keyup)="setNavigationDisable()" [formControl]="cityFormControl" [(ngModel)]="leiDetail.invoiceDetails.address.city">
            <mat-error *ngIf="cityFormControl.hasError('required')">
              City is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width ">
            <input matInput placeholder="Postcode *" name="postcode" (keyup)="setNavigationDisable()" [formControl]="postcodeFormControl" [(ngModel)]="leiDetail.invoiceDetails.address.postcode">
            <mat-error *ngIf="postcodeFormControl.hasError('required')">
              Postcode is <strong>required</strong>
            </mat-error>
          </mat-form-field>

        </div>

        <div class="flex form-row">

          <mat-form-field class="horizontal">
            <input type="text" placeholder="Country *" aria-label="Number" matInput [formControl]="invoiceCountryFormControl" [matAutocomplete]="auto"
                   (change)="setNavigationDisable()" [(ngModel)]="leiDetail.invoiceDetails.address.country">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setNavigationDisable()">
              <mat-option *ngFor="let country of invoiceCountries | async" [value]="country">
                {{ country }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="invoiceCountryFormControl.hasError('required')">
              Country is <strong>required</strong>
            </mat-error>
          </mat-form-field>

        </div>

      </fieldset>

      <fieldset *ngIf="(leiDetail.mifidInScope === 'IN' || leiDetail.mifidInScope === 'OPTIN')
                      && isPaymentShowable()">
        <legend class="copy-invoice">Primary Contact for our research offering</legend>


        <app-lei-contact *ngFor="let contact of leiDetail.contacts, let i = index, let last = last"
                         [contact]="contact" [index]="i" [last]="last"
                         (addContactToModel) = "addMoreContactForm()"
                         [defaultName] = "submitterName" [defaultMail] = "submitterEMail"
                         (contactValid) = "setNavigationDisable($event)"
        ></app-lei-contact>

      </fieldset>


    </div>
  </mat-card>
</div>
